import React from 'react'
import styled from 'styled-components'

const Columns = ({ children }) => {
	return <Container>{children}</Container>
}

const Container = styled.div`
	display: flex;
	gap: 2rem;
	margin: 2rem 0;

	h3 + & {
		margin-top: 1.5rem;
	}
`

export default Columns
